import axiosV2Instance from './axiosV2Instance';

export interface SiteExecutor {
  id: number;
  siteId: number;
  siteMemberId?: number;
  displayName: string;
  userId?: number;
  userName?: string;
  userClosed: boolean;
  avatarUrl?: string;
  isExternal: boolean;
  /** Ставка ₽/ч на объекте для «Не указано»; null — подставляется из профиля пользователя */
  defaultHourlyRate?: number | null;
  /** Компенсация за выезд, ₽ за смену; null/0 — не начисляется */
  compensationPerVisit?: number | null;
}

export interface CreateExternalExecutorRequest {
  displayName: string;
}

export interface UpdateExternalExecutorRequest {
  displayName: string;
}

class SiteExecutorsApi {
  async getSiteExecutors(siteId: number): Promise<SiteExecutor[]> {
    const response = await axiosV2Instance.get<SiteExecutor[]>(`/SitesV2/${siteId}/executors`);
    return response.data;
  }

  async createExternalExecutor(siteId: number, displayName: string): Promise<SiteExecutor> {
    const response = await axiosV2Instance.post<SiteExecutor>(
      `/SitesV2/${siteId}/executors/external`,
      { displayName: displayName.trim() }
    );
    return response.data;
  }

  async updateExternalExecutor(siteId: number, executorId: number, displayName: string): Promise<void> {
    // PUT: на проде nginx в CORS разрешает POST/PUT, но не PATCH.
    await axiosV2Instance.put(
      `/SitesV2/${siteId}/executors/${executorId}`,
      { displayName: displayName.trim() }
    );
  }

  async deleteExternalExecutor(siteId: number, executorId: number): Promise<void> {
    await axiosV2Instance.delete(`/SitesV2/${siteId}/executors/${executorId}`);
  }

  async updateExecutorDefaultHourlyRate(
    siteId: number,
    executorId: number,
    defaultHourlyRate: number | null
  ): Promise<void> {
    // PUT: на проде nginx в CORS разрешает POST/PUT, но не PATCH.
    await axiosV2Instance.put(`/SitesV2/${siteId}/executors/${executorId}/default-hourly-rate`, {
      defaultHourlyRate,
    });
  }

  async updateExecutorCompensationPerVisit(
    siteId: number,
    executorId: number,
    compensationPerVisit: number | null
  ): Promise<void> {
    // PUT: на проде nginx в CORS разрешает POST/PUT, но не PATCH.
    await axiosV2Instance.put(`/SitesV2/${siteId}/executors/${executorId}/compensation-per-visit`, {
      compensationPerVisit,
    });
  }
}

export const siteExecutorsApi = new SiteExecutorsApi();
